import { DateTime } from "luxon";
import { getPointTime } from "./getPointTime";

export const xTicksCallback = (start?: number) => (pointMinutes: number | string) => {
  const pointTime = getPointTime(Number(pointMinutes), start);

  return pointTime.toLocaleString(DateTime.TIME_SIMPLE);
};
